'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, range) {
  var yMin = d3.min(data, function (d) {
    return Math.min(0, d.m1, d.m2);
  });
  var yMax = d3.max(data, function (d) {
    if (d.current[0] != undefined) {
      return Math.max(0, d.m1, d.m2, d.current[0].value);
    } else {
      return Math.max(0, d.m1, d.m2);
    }
  });
  // the brush can modify the visible range of elements
  data = data.slice(range[0], range[1]);
  var x = d3.scale.ordinal().domain(_.map(data, 'd1')).rangeBands([0, params.width], 0.1, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;